import { Injectable, inject } from '@angular/core';
import { Education, EducationCollection } from '@dges/modules/portfolio/domain';
import { Observable } from 'rxjs';
import {
  Firestore,
  CollectionReference,
  DocumentReference,
  collection,
  collectionData,
  addDoc,
  doc,
  updateDoc,
  deleteDoc,
} from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root',
})
export class EducationCollectionService implements EducationCollection {
  private firestore = inject(Firestore);

  private educationsCollection = collection(
    this.firestore,
    'educations',
  ) as CollectionReference<Education>;

  public getEducation(): Observable<Education[]> {
    return collectionData(this.educationsCollection, {
      idField: 'id',
    }) as Observable<Education[]>;
  }

  public addEducation(education: Education): Promise<DocumentReference<Education>> {
    return addDoc(this.educationsCollection, education);
  }

  public editEducation(education: Education): Promise<void> {
    return updateDoc(doc(this.educationsCollection, String(education.id)), {
      ...education,
    });
  }

  public deleteEducation(education: Education): Promise<void> {
    return deleteDoc(doc(this.educationsCollection, String(education.id)));
  }
}
